$(document).ready(function() {
  headerMenu();
  menuAccordion();
});

function headerMenu() {
  $(".menuToggle").on("click", function(e) {
    e.preventDefault();
    $(".menuToggle, #menuOverlay, .searchToggle, body").toggleClass("active");
    $("body").toggleClass("menu-active");
    if ($(this).hasClass("active")) {
    } else {
      $(".searchToggle").removeClass("active");
    }

    $("#searchField").removeClass("active");
    if ($("#searchField").hasClass("active")) {
      $("#searchField").focus();
    }
  });
  $(".searchToggle").on("click", function(e) {
    e.preventDefault();
    $(this).removeClass("active");
    $("#searchField").toggleClass("active");
    if ($("#searchField").hasClass("active")) {
      $("#searchInput").focus();
    }
  });

  $(document).keyup(function(e) {
    if (e.keyCode == 27 && $(".menuToggle").hasClass("active")) {
      $(".menuToggle").click();
    }
  });
  $(window).scroll(function() {
    if ($(window).scrollTop() >= 60) {
      $(".cheeseburger, .logo").addClass("scrolled");
    } else {
      $(".cheeseburger, .logo").removeClass("scrolled");
    }
  });
}

function menuAccordion() {
  $(".sub-menu").hide();
  $(".current-menu-ancestor .sub-menu").show();

  $(".menu-item-has-children > a").click(function(e) {
    e.preventDefault();
    $(this)
      .next()
      .slideToggle();
    $(this)
      .parent()
      .toggleClass("active");
    return false;
  });
}

function menuResize() {
  $(window).resize(function() {
    if ($(window).width() <= 1100) {
      menuAccordion();
    } else {
    }
  });
}
